import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import api from '../api/API';
import { useAuth } from '../hooks/useAuth';

const MinhasTarefasPage = () => {
  const { user } = useAuth();
  const [tarefas, setTarefas] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregarTarefas = async () => {
    try {
      const response = await api.get('/tasks');
      const minhas = response.data.filter(t => t.id_usuario_responsavel === user.id);
      setTarefas(minhas);
    } catch (error) {
      console.error('Erro ao carregar tarefas:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarTarefas();
  }, [carregarTarefas]);

  const hoje = new Date().toISOString().split('T')[0];
  const tarefasHoje = tarefas.filter(t => t.vencimento === hoje && !t.concluido);
  const atrasadas = tarefas.filter(t => t.vencimento < hoje && !t.concluido);
  const proximas = tarefas.filter(t => t.vencimento > hoje && !t.concluido);

  return (
    <Container fluid className="p-4">
      <h4><FontAwesomeIcon icon={faCalendarDays} className="me-2" />Minhas Tarefas</h4>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <section className="mt-4">
            <h5>Tarefas de Hoje ({tarefasHoje.length})</h5>
            {tarefasHoje.length === 0 ? <p>Nenhuma tarefa para hoje.</p> : (
              tarefasHoje.map(t => (
                <div key={t.id} className="p-2 border-bottom d-flex justify-content-between align-items-center">
                  <span>{t.descricao} <small className="text-muted">({t.projeto})</small></span>
                  <Button size="sm" variant="success" onClick={() => api.put(`/tasks/${t.id}`, { fields: { concluido: true } })}>
                    <FontAwesomeIcon icon={faCheck} />
                  </Button>
                </div>
              ))
            )}
          </section>

          <section className="mt-4">
            <h5><FontAwesomeIcon icon={faTriangleExclamation} className="me-2 text-warning" />Atrasadas ({atrasadas.length})</h5>
            {atrasadas.length === 0 ? <p>Nenhuma tarefa atrasada.</p> : (
              atrasadas.map(t => (
                <div key={t.id} className="p-2 border-bottom d-flex justify-content-between align-items-center">
                  <span>{t.descricao} <small className="text-muted">({t.projeto})</small></span>
                </div>
              ))
            )}
          </section>

          <section className="mt-4">
            <h5><FontAwesomeIcon icon={faCalendarDays} className="me-2" />Próximos Dias ({proximas.length})</h5>
            {proximas.length === 0 ? <p>Nenhuma tarefa futura.</p> : (
              proximas.map(t => (
                <div key={t.id} className="p-2 border-bottom d-flex justify-content-between align-items-center">
                  <span>{t.descricao} <small className="text-muted">({t.projeto})</small></span>
                </div>
              ))
            )}
          </section>
        </>
      )}
    </Container>
  );
};

export default MinhasTarefasPage;
